module.exports = __webpack_public_path__ + "themify.e23a7dcaefbde4e74e26.ttf";


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/assets/fonts/themify.ttf?-fvbane
// module id = ../../../../../src/assets/fonts/themify.ttf?-fvbane
// module chunks = styles